import update from "immutability-helper";
import React from "react";
import { isReadonlyChunk } from "../common";
import { type FormItemSelection } from "../model";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

interface Props {
  templateItem?: server.dto.AdvancingFormTemplateItem
  formItem: server.dto.AdvancingFormItem
  onChange: (template: server.dto.AdvancingFormTemplateItem, newValue: FormItemSelection) => void
}

export default class TemplateEditItem extends React.Component<Props> {
  onRadioButtonClicked = (type: FormItemSelection) => {
    let templateItem = this.props.templateItem || {
      chunkId: this.props.formItem.chunkId,
      readOnly: false,
      required: false
    };

    templateItem = update(templateItem, {
      readOnly: { $set: type === "readonly" },
      required: { $set: type === "required" }
    });

    this.props.onChange(templateItem, type);
  };

  public render(): JSX.Element {
    const { templateItem, formItem } = this.props;

    let type: FormItemSelection;
    if (templateItem == null) {
      type = "hidden";
    } else if (templateItem.readOnly) {
      type = "readonly";
    } else if (templateItem.required) {
      type = "required";
    } else {
      type = "optional";
    }

    const isReadonlySection = isReadonlyChunk(formItem.chunkId, formItem.type.value);
    const readonlyRadioOptions = [
      { label: RESX.Advancing.Hidden, value: "hidden" },
      { label: RESX.Advancing.ReadOnly, value: "readonly" }
    ];
    const allRadioOptions = [
      ...readonlyRadioOptions,
      { label: RESX.Advancing.Optional, value: "optional" },
      { label: RESX.Advancing.Required, value: "required" }
    ];

    return <>
      <div style={{ width: "100%" }}>
        <div className="margin-bottom-small">{formItem.label}</div>
        <div className="s1_gray">{formItem.subLabel}</div>
      </div>
      <RadioGroup
        wrapperClassName="advancing-template-row-radio"
        orientation="horizontal"
        options={isReadonlySection ? readonlyRadioOptions : allRadioOptions}
        value={type}
        onChange={this.onRadioButtonClicked}
      />
      {/* Placeholder for empty grid items */}
      {isReadonlySection && <>
        <div />
        <div />
      </>}
    </>;
  }
}
